import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/PelletsCheckoutDataProvider";
import { DataContext as CalculatorContext } from "../../../../../../providers/PelletsDataProvider";
import NewFormRow from "../../../../../shared/forms/NewFormRow";
import NewSelect from "../../../../../shared/forms/NewSelect";

const Hose = () => {
    const dataContext = useContext(DataContext);
    const calculatorContext = useContext(CalculatorContext);

    const { hose } = dataContext.data;
    const { setHose, detailsHasChanged } = dataContext.actions;
    const { additions } = calculatorContext.data;

    /**
     * When the hose changes.
     */
    const onChangeHose = (event) => {
        setHose(event.target.value);
        detailsHasChanged();
    };

    if (additions) {
        return (
            <NewFormRow>
                <NewFormRow.Label>Schlauchlänge</NewFormRow.Label>
                <NewFormRow.Value>
                    <NewSelect
                        onChange={onChangeHose}
                        value={hose}
                        options={Object.keys(additions.hoses).map((key) => {
                            return {
                                value: key,
                                text:
                                    String(
                                        `bis ${additions.hoses[key].name} `
                                    ) +
                                    String(
                                        additions.hoses[key].add !== "0,00"
                                            ? ` (+${additions.hoses[key].add} €)`
                                            : ""
                                    ),
                            };
                        })}
                    />
                </NewFormRow.Value>
            </NewFormRow>
        );
    }

    return null;
};

export default Hose;
